const showPresenters = {
  "0,7 po 20": {
    name: "Paweł Zadorożny, DJ Mateusz Mati Pawłowicz",
    image: "mat_zad.JPG"
  },
    "Półtora Godziny Półtoraka": {
    name: "Przmek Marcin Półtorak",
    image: "poltorak.jpg"
  },
  "Rap Gie": {
    name: "DJ GIE - Guillermo Herrera",
    image: "gije.jpg"
  },
  "The 70's Show": {
    name: "Stefan Badura",
    image: "dj_stefan.jpeg"
  },
  "Kawa i Promile": {
    name: "Paweł Zadorożny",
    image: "zad.jpg"
  },
  "Jazzujemy z Promilem": {
    name: "Kocur Janusz Wróbliński",
    image: "kocur.jpeg"
  }
};

export default showPresenters;